import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { resolveChatMessagingUiEnabled, whenAccessFeaturesReady } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'

import { setChatPropsResolver } from './lazy-route-props'

export async function chatBeforeEnter (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> {
  await whenAccessFeaturesReady()
  if (!resolveChatMessagingUiEnabled()) {
    next({ name: pathNames.MAIN })
    return
  }

  const [{ chatPropsFn }, { beforeEnterChatPageSafe }] = await Promise.all([
    import('./chatPropsFn'),
    import('@/pages/view-chat'),
  ])
  setChatPropsResolver(chatPropsFn)
  if (!to.meta) {
    to.meta = {}
  }
  to.meta.viewChatProps = chatPropsFn(to)
  await beforeEnterChatPageSafe(to)
  next()
}
